import React from 'react'
import {iconSize} from '../shared/styles'

const resizeFactor = 1 + 1 / 3

const styles = (size) => ({
    icon: {
        display: 'inline-block',
        width: `${resizeFactor * iconSize[size]}px`,
        height: `${resizeFactor * iconSize[size]}px`
    },
    img: {
        background: 'none repeat scroll 0 0 #ffffff',
        borderRadius: '50%',
        height: `${resizeFactor * iconSize[size]}px`,
        width: `${resizeFactor * iconSize[size]}px`
    }
})

const UserPhotoIcon = ({src, size}) => {
    const {img, icon} = styles(size)

    return (
        <div className="icon" style={icon}>
            <img alt="" src={src} style={img} />
        </div>
    )
}

export default UserPhotoIcon
